import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import { useTimeZone } from '../../../../hooks'
import { FormModalBody } from '../../../Form'
import { useCalendarDayLoad } from '../../Calendar.hooks'
import { getCalendarTaskMoveDate } from '../CalendarTaskMoveModal.utils'

function CalendarTaskMoveModalBody({
  actionsProps,
  formFieldsProps,
  ...restProps
}) {
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  const cancelRef = useRef(null)

  const { dayLoad, isFailed, isLoading } = useCalendarDayLoad({
    date: getCalendarTaskMoveDate({ timezone, values }),
    requestIds: EMPTY_LIST,
  })

  useEffect(() => {
    cancelRef.current?.focus()
  }, [])

  return (
    <FormModalBody
      {...restProps}
      actionsProps={{
        ...actionsProps,
        cancelProps: { ...actionsProps.cancelProps, elementRef: cancelRef },
        submitProps: { disabled: isLoading },
      }}
      formFieldsProps={{ ...formFieldsProps, dayLoad, isFailed }}
    />
  )
}

export default CalendarTaskMoveModalBody
